"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _allTemplates = require("../../../allTemplates.js");
var _helpers = require("../../../other/helpers.js");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fields = ['showOneElementPerPage', 'showRequiredState', 'showQuestionNumbers', 'showAdvancedSettings', 'playerTemplate', 'playerTemplateSettings', 'overrideAccommodations', 'accommodations.masking', 'accommodations.highlighting', 'accommodations.autoplayQuestions', 'accommodations.autoplayChoices', 'accommodations.autoplayInstructions', 'accommodations.blockUserInteractions'];
var validate = function validate(values) {
  var errors = {};
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getTemplateList", function () {
      var flowType = _this.props.settings.type;
      if (!flowType) {
        return [];
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      return (0, _allTemplates.getTemplateList)('players', flowTypeInfo.playerType);
    });
    _defineProperty(_assertThisInitialized(_this), "_onTemplateChange", function (event) {
      var _this$props$fields = _this.props.fields,
        playerTemplate = _this$props$fields.playerTemplate,
        playerTemplateSettings = _this$props$fields.playerTemplateSettings;
      var newTemplateName = event.target.value;
      var availableTemplates = _this._getTemplateList();
      var newTemplate = (0, _find2["default"])(availableTemplates, {
        name: newTemplateName
      });
      var newTemplateSettings = newTemplate ? newTemplate.defaultSettings : {};
      playerTemplate.onChange(newTemplateName);
      playerTemplateSettings.onChange(newTemplateSettings);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTemplateBlock", function () {
      var _this$props$fields2 = _this.props.fields,
        playerTemplate = _this$props$fields2.playerTemplate,
        playerTemplateSettings = _this$props$fields2.playerTemplateSettings;
      var availableTemplates = _this._getTemplateList();
      var templateSettingsComponent = null;
      var currentTemplate = (0, _find2["default"])(availableTemplates, {
        name: playerTemplate.value
      });
      if (currentTemplate && currentTemplate.settingsComponent) {
        var SettingsComponent = currentTemplate.settingsComponent;
        templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
          initialValues: _objectSpread(_objectSpread({}, currentTemplate.defaultSettings), playerTemplateSettings.value),
          onChange: playerTemplateSettings.onChange
        });
      }
      var showTemplateSelectbox = availableTemplates.length > 1;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Player style",
        show: true,
        type: "primary"
      }, showTemplateSelectbox && /*#__PURE__*/_react["default"].createElement("div", {
        className: !templateSettingsComponent ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: playerTemplate,
        label: "Template"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(playerTemplate), {
        className: "form-control",
        style: {
          width: 'auto'
        },
        onChange: _this._onTemplateChange
      }), availableTemplates.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: item.name,
          key: item.name
        }, item.title);
      })))), templateSettingsComponent);
    });
    _defineProperty(_assertThisInitialized(_this), "_changeOverrideAccommodations", function (event) {
      var _this$props$fields3 = _this.props.fields,
        overrideAccommodations = _this$props$fields3.overrideAccommodations,
        _this$props$fields3$a = _this$props$fields3.accommodations,
        masking = _this$props$fields3$a.masking,
        highlighting = _this$props$fields3$a.highlighting,
        autoplayQuestions = _this$props$fields3$a.autoplayQuestions,
        autoplayChoices = _this$props$fields3$a.autoplayChoices,
        autoplayInstructions = _this$props$fields3$a.autoplayInstructions,
        blockUserInteractions = _this$props$fields3$a.blockUserInteractions;
      var list = [masking, highlighting, autoplayQuestions, autoplayChoices, autoplayInstructions, blockUserInteractions];
      overrideAccommodations.onChange(event);
      list.forEach(function (item) {
        return !item.value && item.onChange(false);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderAccommodationsBlock", function () {
      var _this$props$fields4 = _this.props.fields,
        overrideAccommodations = _this$props$fields4.overrideAccommodations,
        _this$props$fields4$a = _this$props$fields4.accommodations,
        masking = _this$props$fields4$a.masking,
        highlighting = _this$props$fields4$a.highlighting,
        autoplayQuestions = _this$props$fields4$a.autoplayQuestions,
        autoplayChoices = _this$props$fields4$a.autoplayChoices,
        autoplayInstructions = _this$props$fields4$a.autoplayInstructions,
        blockUserInteractions = _this$props$fields4$a.blockUserInteractions;
      var list = [{
        field: masking,
        label: 'Masking'
      }, {
        field: highlighting,
        label: 'Highlighting'
      }, {
        field: autoplayQuestions,
        label: 'Autoplay questions'
      }, {
        field: autoplayChoices,
        label: 'Autoplay choices'
      }, {
        field: autoplayInstructions,
        label: 'Autoplay instructions'
      }, {
        field: blockUserInteractions,
        label: 'Block user interactions till audio is played'
      }];
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Accommodations",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0px'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(overrideAccommodations), {
        checked: !!overrideAccommodations.value,
        onChange: _this._changeOverrideAccommodations
      })), ' ', "Override accommodations")), overrideAccommodations.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: masking,
        label: "New accommodations",
        style: {
          marginTop: '1em'
        }
      }, list.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.field.name,
          className: "checkbox",
          style: {
            margin: '0px'
          }
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "checkbox"
        }, (0, _domOnlyProps["default"])(item.field))), " ", item.label));
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderPlayerBlock", function () {
      var _this$props = _this.props,
        _this$props$fields5 = _this$props.fields,
        showOneElementPerPage = _this$props$fields5.showOneElementPerPage,
        showRequiredState = _this$props$fields5.showRequiredState,
        showQuestionNumbers = _this$props$fields5.showQuestionNumbers,
        showAdvancedSettings = _this$props$fields5.showAdvancedSettings,
        flowPlayerType = _this$props.flowPlayerType;
      if (flowPlayerType !== 'flow') {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Player settings",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showOneElementPerPage))), " Show one element per page")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showRequiredState))), " Show required state as an asterisk")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showQuestionNumbers))), " Show question numbers")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showAdvancedSettings))), " Show advanced settings"))));
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        submitting = _this$props2.submitting;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, this._renderTemplateBlock(), this._renderPlayerBlock(), this._renderAccommodationsBlock(), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        onClick: handleSubmit,
        isLoading: submitting
      })));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  valid: _propTypes["default"].bool,
  values: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  settings: _propTypes["default"].object,
  flowPlayerType: _propTypes["default"].string
});
var _default = (0, _reduxForm.reduxForm)({
  form: 'flowSettingsForm',
  fields: fields,
  validate: validate
})(Form);
exports["default"] = _default;